import { GetPublicWorkspaceByIdResponseDTO } from '@gearbelt/global';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type AuthTokens = {
  accessToken: string;
  accessTokenExpiration?: number;
  refreshToken: string;
  refreshTokenId: string;
};

interface AWAStoreState {
  dailyInspectionGuardOverrideIds: string[];
  workspace: GetPublicWorkspaceByIdResponseDTO['workspace'] | null;
  authTokens: AuthTokens | null;
}

interface AWAStoreActions {
  setDailyInspectionGuardOverrideIds: (ids: string[]) => void;
  setWorkspace: (workspace: GetPublicWorkspaceByIdResponseDTO['workspace'] | null) => void;
  setAuthTokens: (authTokens: AuthTokens | null) => void;
}

export const useAWAStore = create<AWAStoreState & AWAStoreActions>()(
  persist(
    (set) => ({
      dailyInspectionGuardOverrideIds: [],
      workspace: null,
      user: null,
      authTokens: null,
      setDailyInspectionGuardOverrideIds: (dailyInspectionGuardOverrideIds: string[]) => set(() => ({ dailyInspectionGuardOverrideIds })),
      setWorkspace: (workspace: GetPublicWorkspaceByIdResponseDTO['workspace'] | null) => set(() => ({ workspace })),
      setAuthTokens: (authTokens: AuthTokens | null) => set(() => ({ authTokens })),
    }),
    {
      name: 'gb-awa',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
useAWAStore.setState((state) => ({ ...state }));
